import { styled } from '@mui/system';
import { Popover } from '@mui/material';

const error = {
  color: '#C30930',
  backgroundColor: '#FDCED8',
  border: '2px solid #C30930',
};

const tertiary = {
  color: '#00A6FF',
  backgroundColor: '#EBF8FF',
  border: 'none',
};

export const dropDownButtonStyle = {
  primary: {
    contained: {
      default: {
        border: 'none',
        backgroundColor: 'var(--Primary-500, #16124C)',
        color: 'var(--Neutrals-100, #FFF)',
        opacity: 1,
      },
      hover: {
        border: 'none',
        backgroundColor: 'var(--Primary-300, #454170)',
        color: 'var(--Neutrals-100, #FFF)',
        opacity: 0.5,
      },
      disabled: {
        border: 'none',
        color: 'var(--Primary-300, #454170)',
        opacity: 0.25,
      },
    },
    outlined: {
      default: {
        border: '2px solid var(--Primary-500, #16124C)',
        backgroundColor: 'none',
        color: 'var(--Primary-500, #16124C)',
      },
      hover: {
        border: '2px solid var(--Primary-300, #454170)',
        backgroundColor: 'none',
        color: 'var(--Primary-500, #16124C)',
        opacity: 0.25,
      },
      disabled: {
        border: '2px solid var(--Primary-500, #16124C)',
        backgroundColor: 'none',
        color: 'var(--Primary-500, #16124C)',
        opacity: 0.25,
      },
    },
    text: {
      default: {
        border: null,
        backgroundColor: null,
        color: 'var(--Primary-500, #16124C)',
      },
      hover: {
        border: null,
        backgroundColor: 'var(--Primary-500, #16124C)',
        color: 'var(--Neutrals-100, #FFF)',
      },
      disabled: {
        border: null,
        backgroundColor: 'var(--Neutrals-100, #FFF)',
        color: 'var(--Neutrals-700, #C6CCD2)',
        opacity: 0.5,
      },
    },
  },
  secondary: {
    contained: {
      default: {
        border: 'none',
        backgroundColor: 'var(--Secondary-500, #AC5CCC)',
        color: 'var(--Neutrals-100, #FFF)',
      },
      hover: {
        border: 'none',
        backgroundColor: 'var(--Secondary-300, #CD9DE0)',
        color: 'var(--Neutrals-100, #FFF)',
      },
      disabled: {
        border: 'none',
        backgroundColor: 'var(--Secondary-100, #F2DCFA)',
        color: 'var(--Neutrals-100, #FFF)',
      },
    },
    outlined: {
      default: {
        border: '2px solid var(--Secondary-500, #AC5CCC)',
        backgroundColor: 'none',
        color: 'var(--Secondary-500, #AC5CCC)',
      },
      hover: {
        border: '2px solid var(--Secondary-500, #AC5CCC)',
        backgroundColor: 'none',
        color: 'var(--Secondary-500, #AC5CCC)',
        opacity: 0.5,
      },
      disabled: {
        border: '2px solid var(--Secondary-500, #AC5CCC)',
        backgroundColor: 'none',
        color: 'var(--Secondary-500, #AC5CCC)',
        opacity: 0.25,
      },
    },
  },

  tertiary: {
    //this is not in the resuable design (), only put the values in publish dash design for use in publish dash modal
    contained: {
      default: {
        ...tertiary,
      },
      hover: {
        ...tertiary,
        opacity: 0.8,
      },
      disabled: {
        ...tertiary,
        backgroundColor: 'var(--Primary-500, #16124C)',
        color: 'var(--Neutrals-100, #FFF)',
        opacity: 0.1,
      },
    },
    outlined: {
      default: {
        ...tertiary,
        backgroundColor: 'none',
      },
      hover: {
        ...tertiary,
        backgroundColor: 'none',
        opacity: 0.8,
      },
      disabled: {
        ...tertiary,
        backgroundColor: 'none',
        opacity: 0.5,
      },
    },
    both: {
      default: {
        border: '2px solid var(--Tertiary-500, #00A6FF)',
        backgroundColor: 'var(--Tertiary-100, #EBF8FF)',
        color: 'var(--Tertiary-500, #00A6FF)',
      },
      hover: {
        border: 'none',
        backgroundColor: 'var(--Tertiary-100, #EBF8FF)',
        color: 'var(--Tertiary-500, #00A6FF)',
      },
      disabled: {
        border: '2px solid var(--Secondary-500, #AC5CCC)',
        backgroundColor: 'none',
        color: 'var(--Secondary-500, #AC5CCC)',
        opacity: 0.25,
      },
    },
  },

  error: {
    contained: {
      default: {
        ...error,
      },
      hover: {
        ...error,
        opacity: 0.8,
      },
      disabled: {
        ...error,
        opacity: 0.5,
      },
    },
    text: {
      default: {
        ...error,
      },
      hover: {
        ...error,
        opacity: 0.8,
      },
      disabled: {
        ...error,
        border: null,
      },
    },
    outlined: {
      default: {
        ...error,
        backgroundColor: 'none',
      },
      hover: {
        ...error,
        backgroundColor: 'none',
        opacity: 0.8,
      },
      disabled: {
        ...error,
        backgroundColor: 'none',
        opacity: 0.5,
      },
    },
  },

  success: {
    //this is not in the resuable design (), only put the values in publish dash design for use in publish dash modal
    // contained: {
    //   default: {
    //     border: "none",
    //     backgroundColor: "var(--Secondary-500, #AC5CCC)",
    //     color: 'var(--Neutrals-100, #FFF)',
    //   },
    //   hover: {
    //     border: "none",
    //     backgroundColor: "var(--Secondary-300, #CD9DE0)",
    //     color: 'var(--Neutrals-100, #FFF)',
    //   },
    //   disabled: {
    //     border: "none",
    //     backgroundColor: "var(--Secondary-100, #F2DCFA)",
    //     color: 'var(--Neutrals-100, #FFF)',
    //   },
    // },
    // outlined: {
    //   default: {
    //     border: "2px solid var(--Secondary-500, #AC5CCC)",
    //     backgroundColor: "none",
    //     color: 'var(--Secondary-500, #AC5CCC)',
    //   },
    //   hover: {
    //     border: "2px solid var(--Secondary-500, #AC5CCC)",
    //     backgroundColor: "none",
    //     color: 'var(--Secondary-500, #AC5CCC)',
    //     opacity: 0.5,
    //   },
    //   disabled: {
    //     border: "2px solid var(--Secondary-500, #AC5CCC)",
    //     backgroundColor: "none",
    //     color: 'var(--Secondary-500, #AC5CCC)',
    //     opacity: 0.25,
    //   },
    // },
    both: {
      default: {
        border: '2px solid var(--Success-500, #7ED321)',
        backgroundColor: 'var(--Success-100, #E6F8D3)',
        color: 'var(--Success-700, #69B01C)',
      },
      hover: {
        border: 'none',
        backgroundColor: '#44416d',
        color: 'var(--Neutrals-100, #FFF)',
      },
      disabled: {
        border: '2px solid var(--Secondary-500, #AC5CCC)',
        backgroundColor: 'none',
        color: 'var(--Secondary-500, #AC5CCC)',
        opacity: 0.25,
      },
    },
    text: {
      default: {
        border: null,
        backgroundColor: null,
        color: 'var(--Primary-500, #16124C)',
      },
      hover: {
        border: null,
        backgroundColor: 'var(--Primary-500, #16124C)',
        color: 'var(--Neutrals-100, #FFF)',
      },
      disabled: {
        border: null,
        backgroundColor: 'var(--Neutrals-100, #FFF)',
        color: 'var(--Neutrals-700, #C6CCD2)',
        opacity: 0.5,
      },
    },
  },

  selectInWidgetCard: {
    outlined: {
      default: {
        border: '1.5px solid var(--Neutrals-500, #E2E6E9)',
        backgroundColor: 'var(--Neutrals-100, #FFF)',
        color: 'var(--Blacks-500, #100C08)',
      },
      hover: {
        border: '1.5px solid var(--Tertiary-500, #00A6FF)',
        background: 'var(--Neutrals-100, #FFF)',
        opacity: 0.25,
      },
      error: {
        border: '1.5px solid var(--Errors-500, #C30930)',
        background: 'var(--Neutrals-100, #FFF)',
        opacity: 0.25,
      },
      // disabled: {
      //   border: "2px solid var(--Primary-500, #16124C)",
      //   backgroundColor: "none",
      //   color: 'var(--Primary-500, #16124C)',
      //   opacity: 0.25,
      // },
    },
  },

  borderRadius: {
    rectangle: '6px',
    rounded: '30px',
  },
};

export const StyledPopover = styled(Popover)(({ theme }) => ({
  '& .MuiPaper-root': {
    display: 'flex',
    padding: '6px 0px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: '#FFF',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    width: '100%', // Ensuring the Popover matches the width of the anchor element
  },
}));
